// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__9DRZ8","title":"ClientInsurance_title__1QQhE","itemText":"ClientInsurance_itemText__19dhU"};